<mat-card appearance="outlined" class="se-block">
    <div class="measures-content">
        <global-annotations *ngIf="showGlobalMeasures" [annotations]="globalMeasures" [class.se-read-only]="readOnly">
        </global-annotations>
        <custom-measures
            (closeClicked)="onCloseCustomMeasures()"
            (measureChange)="onManualMeasureChange($event)"
            *ngIf="showCustomMeasures"
            [isApprovedOrSigned]="isApprovedOrSigned"
            [measures]="customMeasures"
            [readOnly]="readOnly"
        >
        </custom-measures>
        <caliper-measures
            (measuresRemove)="onCaliperMeasuresRemove($event)"
            (measuresRemoveAll)="onCaliperMeasuresRemoveAll()"
            (measuresSet)="onCaliperMeasuresSet($event)"
            *ngIf="showCaliperMeasures"
            [customMeasureButtons]="customMeasureButtons"
            [measuresList]="caliperMeasures"
            [readOnly]="readOnly"
            class="caliper-measures"
        >
        </caliper-measures>
    </div>
</mat-card>
